var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3644_32062",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3644_32062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#F4679D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#F4679D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#F4679D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17V15C10.5 14.7167 10.5979 14.4792 10.7938 14.2875C10.9896 14.0958 11.225 14 11.5 14H13.1375C13.3042 14 13.4625 14.0417 13.6125 14.125C13.7625 14.2083 13.8833 14.3208 13.975 14.4625C14.2167 14.7875 14.5146 15.0417 14.8688 15.225C15.2229 15.4083 15.6 15.5 16 15.5C16.4083 15.5 16.7896 15.4083 17.1438 15.225C17.4979 15.0417 17.7917 14.7875 18.025 14.4625C18.1333 14.3208 18.2604 14.2083 18.4062 14.125C18.5521 14.0417 18.7042 14 18.8625 14H20.5C20.7833 14 21.0208 14.0958 21.2125 14.2875C21.4042 14.4792 21.5 14.7167 21.5 15V17H18V15.8625C17.7083 16.0708 17.3938 16.2292 17.0563 16.3375C16.7188 16.4458 16.3667 16.5 16 16.5C15.6417 16.5 15.2917 16.4438 14.95 16.3313C14.6083 16.2188 14.2917 16.0583 14 15.85V17H10.5ZM16 15C15.6833 15 15.3833 14.9271 15.1 14.7812C14.8167 14.6354 14.5792 14.4333 14.3875 14.175C14.2458 13.9667 14.0688 13.8021 13.8563 13.6813C13.6438 13.5604 13.4125 13.5 13.1625 13.5C13.3458 13.1917 13.7333 12.9479 14.325 12.7687C14.9167 12.5896 15.475 12.5 16 12.5C16.525 12.5 17.0833 12.5896 17.675 12.7687C18.2667 12.9479 18.6542 13.1917 18.8375 13.5C18.5958 13.5 18.3667 13.5604 18.15 13.6813C17.9333 13.8021 17.7542 13.9667 17.6125 14.175C17.4292 14.4417 17.1958 14.6458 16.9125 14.7875C16.6292 14.9292 16.325 15 16 15ZM12 13.5C11.5833 13.5 11.2292 13.3542 10.9375 13.0625C10.6458 12.7708 10.5 12.4167 10.5 12C10.5 11.575 10.6458 11.2187 10.9375 10.9312C11.2292 10.6437 11.5833 10.5 12 10.5C12.425 10.5 12.7813 10.6437 13.0688 10.9312C13.3563 11.2187 13.5 11.575 13.5 12C13.5 12.4167 13.3563 12.7708 13.0688 13.0625C12.7813 13.3542 12.425 13.5 12 13.5ZM20 13.5C19.5833 13.5 19.2292 13.3542 18.9375 13.0625C18.6458 12.7708 18.5 12.4167 18.5 12C18.5 11.575 18.6458 11.2187 18.9375 10.9312C19.2292 10.6437 19.5833 10.5 20 10.5C20.425 10.5 20.7813 10.6437 21.0688 10.9312C21.3563 11.2187 21.5 11.575 21.5 12C21.5 12.4167 21.3563 12.7708 21.0688 13.0625C20.7813 13.3542 20.425 13.5 20 13.5ZM16 12C15.5833 12 15.2292 11.8542 14.9375 11.5625C14.6458 11.2708 14.5 10.9167 14.5 10.5C14.5 10.075 14.6458 9.71875 14.9375 9.43125C15.2292 9.14375 15.5833 9 16 9C16.425 9 16.7812 9.14375 17.0687 9.43125C17.3562 9.71875 17.5 10.075 17.5 10.5C17.5 10.9167 17.3562 11.2708 17.0687 11.5625C16.7812 11.8542 16.425 12 16 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGroup);
export default __webpack_public_path__ + "static/media/support_group.79c6bc3977c586278eec156149f06533.svg";
export { ForwardRef as ReactComponent };